export default [
    {
        key: "polka",
        allArray: "allPolkaTelezhka",
        activeArray: "activePolkaTelezhka",
        position: "bottom",
    },
];
